export const pxContainer = 2;
export const py = 2;

export const titleStyles = {
  fontWeight: "bold",
  pt: 4,
};
